import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "latitude","longitude","location",
    "items","totalCost",
    "typeSelect","completeByGroup","timeQuantity","timeUnit"
  ]

connect() {
  console.log("InvoiceController v4 connected")
  this.initializeTotals()
  this.fetchLocationAndAutofill()
  this.initializeDefaultStates()

  // Run once after the DOM is painted to reflect current value
  requestAnimationFrame(() => this.toggleCompleteBy())
}


toggleCompleteBy() {
  if (!this.hasTypeSelectTarget || !this.hasCompleteByGroupTarget) return
  const val = (this.typeSelectTarget.value || "").trim().toUpperCase()
  const show = (val === "ESTIMATE")

  this.completeByGroupTarget.classList.toggle("d-none", !show)
  this.completeByGroupTarget.hidden = !show

  if (this.hasTimeQuantityTarget) {
    this.timeQuantityTarget.disabled = !show
    if (!show) this.timeQuantityTarget.value = ""
  }
  if (this.hasTimeUnitTarget) {
    this.timeUnitTarget.disabled = !show
    if (!show) this.timeUnitTarget.selectedIndex = 0
  }
}


  // ✅ Geolocation → send coords to backend for reverse geocode
  async fetchLocationAndAutofill() {
    if (!navigator.geolocation) return

    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        if (this.hasLatitudeTarget) this.latitudeTarget.value = coords.latitude
        if (this.hasLongitudeTarget) this.longitudeTarget.value = coords.longitude

        // ✅ Only reverse geocode if location field is still blank
        if (this.hasLocationTarget && !this.locationTarget.value.trim()) {
          try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            const response = await fetch("/geocoders/reverse_geocode", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken
              },
              body: JSON.stringify({
                latitude: coords.latitude,
                longitude: coords.longitude
              })
            })

            const data = await response.json()
            if (data.success && data.address) {
              this.locationTarget.value = data.address
              console.log("✅ Location autofilled:", data.address)
            } else {
              console.error("❌ Backend geocode error:", data.error)
            }
          } catch (error) {
            console.error("🌐 AJAX fetch to reverse_geocode failed:", error)
          }
        }
      },
      (error) => console.warn("📍 Browser geolocation error:", error)
    )
  }

// ✅ Total cost recalculation
initializeTotals() {
  if (this.hasItemsTarget) this.updateTotal()
}

updateTotal() {
  if (!this.hasItemsTarget) return

  let total = 0

  this.itemsTarget.querySelectorAll(".nested-fields").forEach(row => {
    const quantity = parseFloat(row.querySelector(".item-quantity")?.value || 0)
    const value    = parseFloat(row.querySelector(".item-value")?.value || 0)
    const itemTotal = quantity * value

    const itemTotalField = row.querySelector(".item-total")
    if (itemTotalField) {
      itemTotalField.textContent = itemTotal.toFixed(2)
    }

    total += itemTotal
  })

  if (this.hasTotalCostTarget) {
    this.totalCostTarget.textContent = total.toFixed(2)
  }
}

addItem(event) {
    event.preventDefault()
    let tmpl = document.getElementById("item-template")
    if (!tmpl) { console.error("Missing #item-template"); return }

    const html = tmpl.innerHTML.trim()
    if (!html) { console.error("Empty item template"); return }

    const key = Date.now().toString()
    const replaced = html
      .replaceAll("[NEWITEM]", `[${key}]`)
      .replaceAll("_NEWITEM_", `_${key}_`)

    const wrapper = document.createElement("div")
    wrapper.innerHTML = replaced
    this.itemsTarget.appendChild(wrapper.firstElementChild)
    this.updateTotal()
  }


  // ✅ Remove an item row
  removeItem(event) {
    event.target.closest(".nested-fields")?.remove()
    this.updateTotal()
  }

  // ✅ Handle asset type selection
  changeAssetType(event) {
    const type = event.target.dataset.type
    const wrapper = event.target.closest(".nested-fields")
    const hiddenInput = wrapper.querySelector(".asset-type-hidden-field")
    if (hiddenInput) hiddenInput.value = type

    // Reset buttons
    wrapper.querySelectorAll(".asset-type-btn").forEach(btn => {
      btn.classList.remove("btn-selected")
      btn.style.backgroundColor = ""
      btn.style.color = ""
    })

    event.target.classList.add("btn-selected")
    event.target.style.backgroundColor = "black"
    event.target.style.color = "white"

    // Show/hide type-specific fields
    wrapper.querySelectorAll(".car-fields, .house-fields, .boat-fields").forEach(f => f.classList.add("d-none"))
    if (type === "Car") wrapper.querySelectorAll(".car-fields").forEach(f => f.classList.remove("d-none"))
    if (type === "House") wrapper.querySelectorAll(".house-fields").forEach(f => f.classList.remove("d-none"))
    if (type === "Boat") wrapper.querySelectorAll(".boat-fields").forEach(f => f.classList.remove("d-none"))
  }

  // ✅ Setup defaults on page load
  initializeDefaultStates() {
    this.itemsTarget.querySelectorAll(".nested-fields").forEach(wrapper => {
      const defaultBtn = wrapper.querySelector(".asset-type-btn[data-type='Standard']")
      if (defaultBtn) {
        defaultBtn.classList.add("btn-selected")
        defaultBtn.style.backgroundColor = "black"
        defaultBtn.style.color = "white"
      }
      wrapper.querySelectorAll(".car-fields, .house-fields, .boat-fields").forEach(f => f.classList.add("d-none"))
    })
  }

  // ✅ Auto-update totals on quantity or value input
  updateOnInput(event) {
    if (event.target.classList.contains("item-quantity") || event.target.classList.contains("item-value")) {
      this.updateTotal()
    }
  }
}
